import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PinInput from "react-pin-input";
import CircularProgress from "@mui/material/CircularProgress";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "92%",
  maxWidth: 420,
  bgcolor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
  outline: "none",
  p: "24px",
  maxHeight: "90vh",
  overflowY: "auto",
};

function PinModal({
  open,
  handleClose,
  onBack,
  onConfirm,
  isLoading,
}) {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setPin("");
    }
  }, [open]);

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (pin.length === 4) {
      if (onConfirm) {
        onConfirm(pin);
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 400,
        sx: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          {/* Header */}
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={onBack || handleClose}
              className="flex items-center gap-2 text-[#1E222B] font-[700] text-[15px] cursor-pointer hover:opacity-80 transition"
            >
              <ArrowBackIcon sx={{ fontSize: 18, color: "#1E222B" }} />
              <span>Back</span>
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="w-9 h-9 rounded-full bg-[#18191B] hover:bg-black text-white flex items-center justify-center cursor-pointer transition shadow-xs"
              aria-label="Close"
            >
              <CloseIcon sx={{ fontSize: 17 }} />
            </button>
          </div>

          {/* Icon & Title */}
          <div className="flex flex-col items-center mt-6">
            <div className="w-12 h-12 rounded-2xl bg-[#E8F8F0] text-[#00BC67] flex items-center justify-center mb-3">
              <LockOutlinedIcon sx={{ fontSize: 24 }} />
            </div>
            <h3 className="text-[18px] font-[700] text-[#1E222B] text-center">
              Enter your Zouse PIN
            </h3>
            <p className="text-[13px] text-[#808285] text-center mt-1 mb-6">
              Enter your 4-digit PIN to confirm transaction
            </p>
          </div>

          {/* PIN Input */}
          <form onSubmit={handleSubmit} className="flex flex-col items-center">
            <div className="py-2">
              <PinInput
                key={open ? "pin-open" : "pin-closed"}
                length={4}
                initialValue=""
                secret
                onChange={(value) => setPin(value)}
                type="numeric"
                inputMode="number"
                style={{ display: "flex", gap: "10px" }}
                inputStyle={{
                  borderColor: "#E5E7EB",
                  backgroundColor: "#F8FAFC",
                  borderRadius: 12,
                  width: "52px",
                  height: "52px",
                  fontSize: "22px",
                  fontWeight: "bold",
                  color: "#1E222B",
                }}
                inputFocusStyle={{
                  borderColor: "#00BC67",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0 0 0 1px #00BC67",
                }}
                onComplete={(value) => {
                  setPin(value);
                }}
                autoSelect={true}
              />
            </div>

            <button
              type="submit"
              disabled={pin.length < 4 || isLoading}
              className="w-full h-[52px] flex items-center justify-center rounded-xl bg-[#00BC67] hover:bg-[#00a85c] disabled:opacity-50 disabled:cursor-not-allowed text-white font-[700] text-[15px] transition shadow-xs cursor-pointer mt-8"
            >
              {isLoading ? (
                <CircularProgress size={20} style={{ color: "white" }} />
              ) : (
                "Confirm Payment"
              )}
            </button>
          </form>
        </Box>
      </Fade>
    </Modal>
  );
}

export default PinModal;
